import {
    Formik,
    FormikProps
} from 'formik';
import {FormComponent} from './FormComponent';
import {RecordSchema} from './RecordSchema';
import {FormWithButtons} from '@flexinet/ui-components';
import {
    ApplicationProduct,
    ApplicationProductFormType,
    ApplicationProductRecordFormProps,
    ApplicationProductStatus
} from '../types';
import {stage} from "../../../config/stage";

export const RecordForm = (
    {
        record,
        handleSubmit,
        handleCancel
    }: ApplicationProductRecordFormProps) => {

    const onSubmit = (values: ApplicationProductFormType) => {
        handleSubmit(values as ApplicationProduct);
    };

    let initialValues = {
        applicationProductStatus: ApplicationProductStatus.ACTIVE,
    } as ApplicationProductFormType;

    if (record) {
        initialValues = {...initialValues, ...record};
    }

    return (
        <Formik<ApplicationProductFormType>
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={handleCancel} debug={false && stage === 'ide'} {...rest} >
                    <FormComponent {...rest as FormikProps<ApplicationProductFormType>}  />
                </FormWithButtons>)}
        </Formik>
    );
};
